import React, { Component } from "react";
import { loginWithFacebook } from "../../actions/userActions";
import { push } from "redux-little-router";
import { connect } from "react-redux";
import { selectUser } from "../../util/selectors";
import { Loader } from "semantic-ui-react";

class LoginPage extends Component {
  render() {
    let { user, push, login } = this.props;
    if (user) {
      push("/");
    } else if (user === null) {
      login();
    }
    return this.props.user === undefined ? (
      <div className="fullscreen">
        <Loader size="large" active inline="centered" />
      </div>
    ) : null;
  }
}
const mapStateToProps = state => ({
  user: selectUser(state),
});
const mapDispatchToProps = dispatch => ({
  login: props => dispatch(loginWithFacebook(props)),
  push: props => dispatch(push(props)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/scenes/LoginPage/index.js